import React, { useReducer, useEffect, useContext, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { toast } from 'react-toastify'
import Layout from './layout';
import Modal from '../../components/Modal';

import api from '../../services/api';
import Cookie from '../../util/cookies';

import AppContext from '../../redux/contexts/appContext';

function Login() {

  const { state, dispatch } = useContext(AppContext);
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [loadingSessionRemake, setLoadingSessionRemake] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);
  const [alertModal, setAlertModal] = useState(null);
  const [formType, setFormType] = useState("LOGIN")

  const onLoginApprove = (user, token, remember = null) => {
    // Cookies setup
    const expireDate = new Date();
    
    if (remember === true) {
      expireDate.setFullYear(expireDate.getFullYear() + 100);
      Cookie.set('token', token, expireDate);
      Cookie.set("UID", user.id, expireDate);
    }
    else if (remember === false) {
      Cookie.set('token', token);
      Cookie.set("UID", user.id);
    }

    


    // Reducer setup
    
    dispatch({type: 'set-user', payload: {...user, token: token}});
  }

  const login = (login, password, remember) => {
    if (
      login.replace(/\s/g, '') == "" ||
      password.replace(/\s/g, '') == ""
    )
    {
      return toast.error("Fill in all fields");
    }

    // Execute login request
    setLoading(true);
    api().post('/session', {login, password})
    .then(response => {
      setLoading(false);
      onLoginApprove(response.data.user, response.data.token, remember);
      
      
    })
    .catch(err => {
      setLoading(false);
      // Show message on error
      if (err?.response?.data?.msg) {
        toast.error(err.response.data.msg)
      }
      else {
      }
    })

  }


  const googleLogin = (googleObj) => {
    setLoading(true);
    api().post('/google/session', {google: googleObj})
    .then(response => {
      setLoading(false);
      onLoginApprove(response.data.user, response.data.token, true);
    })
    .catch(err => {
      setLoading(false);
      // Show message on error
      if (err?.response?.data?.msg) {
        toast.error(err.response.data.msg)
      }
      else {
      }
    })

  }

  const singUp = (email, login, name, password, confirmPassword) => {
    if (password !== confirmPassword) {
      return toast.error("Passwords does not match!");
    }
    if (
      email.replace(/\s/g, '') == "" ||
      login.replace(/\s/g, '') == "" ||
      name.replace(/\s/g, '') == "" ||
      password.replace(/\s/g, '') == "" ||
      confirmPassword.replace(/\s/g, '') == "" 
    )
    {
      return toast.error("Fill in all fields");
    }
      

    setLoading(true);
    const json = {
      login: login,
      name: name,
      email: email,
      password: password
    };
    api().post('/user', json)
    .then(response => {
      setLoading(false);
      setFormType('LOGIN');
      toast.success("We've sent an email to you. Click the link in the email to confirm your account.")
    })
    .catch(err => {
      setLoading(false);
      // Show message on error
      if (err?.response?.data?.msg) {
        toast.error(err.response.data.msg)
      }
      else {
      }
    })
  }

  const onForgotPassword = (email) => {
    if (!email || email.replace(/\s/g, '') == 0) {
      return toast.error("Fill the E-mail field");
    }
    setLoading(true);
    api().post('/user/password/forgot', {email})
    .then(response => {
      setLoading(false);
      setFormType('LOGIN')
      toast.success("We've sent an email to you. Click the link in the email to reset your password.")
    })
    .catch(err => {
      setLoading(false);
      // Show message on error
      if (err?.response?.data?.msg) {
        toast.error(err.response.data.msg)
      }
      else {
      }
    })
  }

  const closeMessageModal = () => {
    setModalMessage(null);
  }

  const onForgotLogin = (email) => {
    if (!email || email.replace(/\s/g, '') == 0) {
      return toast.error("Fill the E-mail field");
    }
    setLoading(true);
    api().post('/user/login/forgot', {email})
    .then(response => {
      setLoading(false);
      setFormType('LOGIN');
      toast.success("We've sent an email to you. Click the link in the email to check your login credential.");
    })
    .catch(err => {
      setLoading(false);
      // Show message on error
      if (err?.response?.data?.msg) {
        toast.error(err.response.data.msg)
      }
      else {
      }
    })
  }

 

  useEffect(() => {
    // Verify previous session
    const token = Cookie.get('token');
    const uid = Cookie.get('UID');

    const trySessionRemake = () => {
      if (!token || !uid) return false;
      setLoadingSessionRemake(true);
      api().post('/session/remake/'+uid, {}, {headers: {'Authorization': "Bearer "+token}})
      .then(response => {
        setLoadingSessionRemake(false);
        onLoginApprove(response.data.user, response.data.token);
      })
      .catch(err => {
        Cookie.delete('token');
        Cookie.delete('UID');
        setLoadingSessionRemake(false);
      })
    }
    trySessionRemake();
  }, [])
  

  return (
    <>
      <Layout closeMessageModal={closeMessageModal} formType={formType} setFormType={setFormType} message={modalMessage} onLogin={login} onGoogleLogin={googleLogin} onSignUp={singUp} onForgotPassword={onForgotPassword} onForgotLogin={onForgotLogin} loading={loading} loadingSessionRemake={loadingSessionRemake}></Layout>
      <Modal visible={alertModal !== null} title={"Alert"} onCancel={() => setAlertModal(null)} onSubmit={() => setAlertModal(null)} cancelText={false} >
        {alertModal}
      </Modal>
    </>
  );
}

export default Login;